import _ from 'lodash'
import { useMemo, useState } from 'react'
import { useGetPatientFormSubmissionsQuery } from '@/core/services/form'
import { useGetPatientConsultationsQuery } from '@/core/services/patient'

export function usePatientConsultations(patientId: string, itemsPerPageOptions: number[]) {
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: itemsPerPageOptions[0],
  })

  const { consultations, totalConsultations } = useGetPatientConsultationsQuery(
    { patientId, options: { limit: paginationState.pageSize, skip: paginationState.pageIndex * paginationState.pageSize, order: 'DESC' } },
    { selectFromResult: ({ data }) => ({ consultations: data?.items, totalConsultations: data?.totalCount ?? 0 }) }
  )
  const { formSubmissions } = useGetPatientFormSubmissionsQuery(
    {
      patientId: patientId!,
      skip: Number(0),
      limit: Number(1000), // Get all submissions for historical view
      order: 'DESC',
      orderBy: 'createdAt',
    },
    { selectFromResult: ({ data }) => ({ formSubmissions: data?.items }) }
  )

  const patientHistoricalConsultations = useMemo(
    () =>
      consultations?.map((consultation) => {
        // Filter submissions for this consultation
        const consultationSubmissions = formSubmissions?.filter((submission) => submission.consultation?._id === consultation._id) || []

        return {
          id: consultation._id,
          pds: {
            fullName: _.trim(`${consultation.pds?.userInfo.name || ''} ${consultation.pds?.userInfo.surname || ''}`),
            gender: consultation.pds?.userInfo.gender,
          },
          doctor: {
            fullName: _.trim(`${consultation.medecin?.userInfo.name || ''} ${consultation.medecin?.userInfo.surname || ''}`),
            gender: consultation.medecin?.userInfo.gender,
          },
          type: consultation.type,
          startDate: consultation.startDate,
          fileCount: consultation.files.length,
          reason: consultation.reason,
          speciality: consultation.speciality,
          status: consultation.status,
          mesures: consultation.mesures,
          biologicals: consultation.biologicals,
          commentaire: consultation.commentaire,
          dictaphones: consultation.dictaphones,
          files: consultation.files,
          formSubmissions: consultationSubmissions,
        }
      }) ?? [],
    [consultations, formSubmissions]
  )

  return { patientHistoricalConsultations, paginationState, setPaginationState, totalConsultations }
}
